import React, { createContext, useState, useCallback } from "react";
import { RenegociacaoContextProps, RenegociacaoProviderProps, RenegociacaoType } from "./types";
import {trackPromise} from "react-promise-tracker";
import RenegociacaoService from "../../services/RenegociacaoService";
import Swal from "sweetalert2";

export const RenegociacaoContext = createContext<RenegociacaoContextProps>({
  buscarRenegociacao: async () => false,
  modalRenegociacaoAberto: false,
  fecharModalRenegociacao: () => {},
  abrirModalRenegociacao: () => {},
  modalValidacaoAberto: false,
  fecharModalValidacao: () => {},
  abrirModalValidacao: () => {},
  renegociacoes: null
});

export function RenegociacaoProvider({ children }: RenegociacaoProviderProps) {
  const [modalRenegociacaoAberto, setRenegociacaoAberto] = useState(false);
  const [modalValidacaoAberto, setModalValidacaoAberto] = useState(false);

  const [renegociacoes, setRenegociacoes] = useState<RenegociacaoType[] | null>(null);

  const buscarRenegociacao = useCallback(async (idProcesso: number): Promise<boolean> => {
    try {
      const response = await trackPromise(RenegociacaoService.buscarRenegociacao(idProcesso));
      setRenegociacoes(response.data.renegociacoes);
      return response.data;
    } catch (error) {
      Swal.fire({
        titleText: "Ooops...",
        text: "Erro ao buscar renegociação!",
        icon: "warning",
      });
      console.error('Erro ao buscar renegociacao', error);
      return false;
    }
  }, [])

  const abrirModalRenegociacao = useCallback(() => {
    setRenegociacaoAberto(true);
  }, [])

  const fecharModalRenegociacao = useCallback(() => {
    setRenegociacaoAberto(false);
  }, [])

  const abrirModalValidacao = useCallback(() => {
    setModalValidacaoAberto(true);
  }, [])

  const fecharModalValidacao = useCallback(() => {
    setModalValidacaoAberto(false);
  }, [])

  return (
    <RenegociacaoContext.Provider value={{ buscarRenegociacao, modalRenegociacaoAberto, fecharModalRenegociacao, abrirModalRenegociacao, renegociacoes, abrirModalValidacao,  fecharModalValidacao, modalValidacaoAberto}}>
      {children}
    </RenegociacaoContext.Provider>
  )
}
